import styled from "styled-components";

export const Wrapper = styled.div`
  @media print {
    // width: 50%;
    width: 100%;
  }
`;
